import * as React from 'react'
import { SvgIcon } from '@mui/material'

function RifleIcon (props) {
  const { color } = props.style
  return (
    <SvgIcon {...props}>
      <svg width="226" height="221" viewBox="0 0 226 221" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 129.5V92C0.5 87.0294 4.52944 83 9.5 83H87.8418C88.28 83 88.7177 83.032 89.1512 83.0958L122.5 88L149.5 94L172.5 100L182.2 103.442C185.677 104.676 188 107.965 188 111.655C188 115.437 185.56 118.787 181.961 119.948L172.5 123L149.5 129.5L122.5 134.5L88.5 138.5H9.5C4.52944 138.5 0.5 134.471 0.5 129.5Z" fill={color}/>
        <path d="M19 217.5L203.562 122.99C212.965 118.175 213.003 104.75 203.628 99.8818L19 4" stroke={color} stroke-width="7" stroke-linecap="round"/>
        <path d="M83 73L4 34" stroke={color} stroke-width="7" stroke-linecap="round"/>
        <path d="M83 148.5L4 187.5" stroke={color} stroke-width="7" stroke-linecap="round"/>
      </svg>
    </SvgIcon>
  )
}

export default RifleIcon
